import React from 'react';
import { shiftSummaryDashboardOverview } from "./FatigueAssessmentPageSelector";
import { FatigueAssessmentView } from './FatigueAssessmentView';
import FatigueAssessmentDashboard from "./FatigueAssessmentDashboard";

const FatigueAssessmentDashboardOverview = () => {
    return (
        <FatigueAssessmentDashboard
            page={shiftSummaryDashboardOverview}
            pageView={FatigueAssessmentView.Overview}
        />
    );
}

export default FatigueAssessmentDashboardOverview;
